var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm.isError ? _c('span', {
    staticClass: "font-italic"
  }, [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Fout bij het ophalen")]), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": _vm.loadSupplyChain
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "rotate"
    }
  })], 1)], 1) : _vm.supplyChain ? _c('span', [_vm._v(" " + _vm._s(_vm.supplyChain) + " ")]) : _c('i', [_vm._v(" geen ruleset gekoppeld ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }